import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';
// import "./Tableform.css";
import { connect } from 'react-redux';
import ReactToPrint from "react-to-print";
import image from "../../../../../images/logo1.png";
import {
    FetchFinalReport, getProjects
} from '../../../store/actions';

import { useRef } from 'react';
import { useParams } from "react-router-dom";
const useStyles = makeStyles({
    table: {
        height: "40px"
    },
    left: {
        margin: 600,
        width: "50%"
    },
    fontsize13: {
        fontSize: "13px",
    },
    rightContentHeader: {
        width: "88%",
        float: "left",
        textAlign: "left",
        paddingRight: "20px",
    },
    style: {
        background: "#AD70A6",
        color: "#fff",
        padding: 10,
        marginLeft: 5,
    }

});
interface Props {
    projects:any;
    getProjects:any;
    FetchFinalReport:any;
    fetchFinalReportData:any;

}
const PhleboAdminViewBooking: React.FC<Props> = ({
    projects,
    getProjects,
    FetchFinalReport,
    fetchFinalReportData,


}) => {
    const classes = useStyles();
    const contentArea = useRef<any>(0)
    const componentRef = useRef<any>(null);
    const [personName, setPersonName] = useState<any>("main")
    const { id } = useParams<{ id: string }>();
    // const handleExportWithFunction = () => {
    //     savePDF(contentArea.current, { paperSize: "A4"});
    //     //  window.print

    // }

    const reactToPrintContent = React.useCallback(() => {
        return componentRef.current;
    }, [componentRef.current]);
    const reactToPrintTrigger = React.useCallback(() => {
        return <button style={{ marginLeft: "10px",backgroundColor:"rebeccapurple",color:"white"}}>Print/Download</button>;
    }, []);

    useEffect(() => {
        getProjects(id);
        // FetchFinalReport();
      
      }, [])
    return (
        <>
            <div>
                <div style={{ height: "40px", marginTop: "35%",width:"250%" }}>
                    <h2></h2>
                    <div className={classes.rightContentHeader}>

                        <ReactToPrint
                            content={reactToPrintContent}
                            trigger={reactToPrintTrigger}
                        />
                    </div>
                </div>
            </div>
            <div
                style={{
                    width: 842,
                    background: "#f1f1f1",
                    margin: "20px auto",
                    padding: 20
                }}
            >
                <div ref={componentRef}>
                    <div style={{ width: "100%", display: "flex", background: "#1289A7", marginTop: "30px" }}>
                        <div style={{ width: "50%", textAlign: "left", padding: 15 }}>
                            <h3><img src={image} alt="logo" style={{ width: "150px" }} /></h3>
                        </div>
                        <div style={{ width: "50%", textAlign: "right", padding: 15 }}>
                            <div style={{ color: "white", fontWeight: "bold" }}><h3>Project Completion Form</h3></div>
                        </div>
                    </div>

                    <div
                        style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "flex-end",
                            margin: "10px 0px",
                            color: "#fff"
                        }}
                    >
                        <div style={{ background: "#33c9dc", padding: 10 }}>Project Id</div>
                        <div
                            style={{
                                padding: "8px 5px",
                                color: "#000",
                                border: "2px solid #000"
                            }}
                        >
                            RCL
                        </div>
                        <input value={projects?.projectId}/>
                    </div>
                    <div
                        style={{
                            width: "100%",
                            background: "#1289A7",
                            textAlign: "center",
                            color: "#fff"
                        }}
                    >
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                        <div style={{ background: "#33c9dc", padding: 10 }}>
                            Project Type:
                        </div>
                        <input style={{ width: "50%", marginLeft: 5 }} value={projects?.sample?.type}/>
                        <div
                            style={{
                                background: "#33c9dc",
                                padding: 10,
                                marginLeft: 5
                            }}
                        >
                            Client Details
                        </div>
                        <input style={{ width: "50%", marginLeft: 5 }}value={projects?.scientist?.name}/>
                    </div>

                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                        <div style={{ background: "#33c9dc", padding: 10 }}>
                            Sample Recived date:
                        </div>
                        <input style={{ width: "50%", marginLeft: 5 }} value={projects?.sample?.createdAt ? projects?.sample?.createdAt?.split("T")[0] : ''}/>
                        <div
                            style={{
                                background: "#33c9dc",
                                padding: 10,
                                marginLeft: 5
                            }}
                        >
                            Project Closer Date
                        </div>
                        <input style={{ width: "50%", marginLeft: 5 }} value={projects?.deliverable?.createdAt ? projects?.deliverable?.closerFormSent?.split("T")[0] : ''}></input>
                    </div>

                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                        <div style={{ background: "#33c9dc", padding: 10 }}>
                            Samples as per Proposal:
                        </div>
                        <input style={{ width: "50%", marginLeft: 5 }}value={projects?.sample?.poCount}/>
                        <div
                            style={{
                                background: "#33c9dc",
                                padding: 10,
                                marginLeft: 5
                            }}
                        >
                            No of Sample(s) Quality Checked
                        </div>
                        <input style={{ width: "50%", marginLeft: 5 }} value={projects?.sample?.receivedCount}/>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <div style={{ background: "#33c9dc",padding: 10 }}>
                            No: of Sample(s) Sequenced
                        </div>
                        <input style={{ width: "50%", marginLeft: 5 }} value={projects?.librariesCount}/>
                        <div
                            style={{
                                background: "#33c9dc",
                                padding: 10,
                                marginLeft: 5
                            }}
                        >
                            Deliverables:
                        </div>
                        <input style={{ width: "50%", marginLeft: 5 }}value={projects?.phase}/>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <div style={{ background: "#33c9dc",padding: 10 }}>
                            Phone No.
                        </div>
                        <input type="number" style={{ width: "50%", marginLeft: 5 }}value={projects?.scientist?.mobile}/>
                        <div
                            style={{
                                background: "#33c9dc",
                                padding: 10,
                                marginLeft: 5
                            }}
                        >
                            Email
                        </div>
                        <input type="email" style={{ width: "50%", marginLeft: 5 }}value={projects?.scientist?.email}/>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <div style={{ background: "#33c9dc",padding: 10 }}>
                            Sample QC Report sent
                        </div>
                        <input type="number" style={{ width: "50%", marginLeft: 5 }}></input>
                        <div
                            style={{
                                background: "#33c9dc",
                                padding: 10,
                                marginLeft: 5
                            }}
                        >
                            Library QC Report sent
                        </div>
                        <input  style={{ width: "50%", marginLeft: 5 }}></input>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <div style={{ background: "#33c9dc", padding: 10 }}>
                            Data QC Report sent
                        </div>
                        <input style={{ width: "50%", marginLeft: 5 }}value={projects?.bioInformatics?.finalDataQcFile!="" ? "Yes" : "No"}/>
                        <div
                            style={{
                                background: "#33c9dc",
                                padding: 10,
                                marginLeft: 5
                            }}
                        >
                            Raw Data Submitted to Client
                        </div>
                        <input style={{ width: "50%", marginLeft: 5 }} value={projects?.bioInformatics?.rawDataShared===true ? "Yes" : "No"}/>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <div style={{ background: "#33c9dc",padding: 10 }}>
                            Raw data achieved
                        </div>
                        <input  style={{ width: "50%", marginLeft: 5 }} value={projects?.bioInformatics?.rawDataSharingMode}/>
                        <div
                            style={{
                                background: "#33c9dc",
                                padding: 10,
                                marginLeft: 5
                            }}
                        >
                            Additional Analysis Report & files sent
                        </div>
                        <input type="email" style={{ width: "50%", marginLeft: 5 }} value={projects?.deliverable?.additionalFile!=="" ? "Yes" : "No"}/>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <div
                            style={{
                                background: "#33c9dc",
                                padding: 10,
                                marginLeft: 2
                            }}
                        >
                            Bioinformatics Analysis Report & Supplementary files sent
                        </div>
                        <input type="email" style={{ width: "100%", marginLeft: 5 }} value={projects?.deliverable?.supplementaryFileSent===true ? "Yes" : "No"}/>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <div style={{ background: "#33c9dc", padding: 10 }}>
                            Library kit used
                        </div>
                        <input type="number" style={{ width: "50%", marginLeft: 5 }}></input>
                        <div
                            style={{
                                background: "#33c9dc",
                                padding: 10,
                                marginLeft: 5
                            }}
                        >
                            Data Submitted in External Drive
                        </div>
                        <input type="email" style={{ width: "50%", marginLeft: 5 }}></input>
                    </div>
                    {/* <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <div
                            style={{
                                background: "#33c9dc",
                                padding: 10,
                                marginLeft: 2
                            }}
                        >
                            Download URL
                        </div>
                        <input type="email" style={{ width: "84%", marginLeft: 5 }}></input>
                    </div> */}
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <h4 style={{
                            display: "inline", marginLeft: 200
                        }}>
                            Declaration by Redcliffe Labs
                        </h4>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <p style={{ display: "inline" }}>
                            We hereby declare that the above-mentioned NGS Project has been completed and all
                            the deliverables are met as per the accepted proposal.
                        </p>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <h4 style={{
                            display: "inline", marginLeft: 220
                        }}>
                            Confirmation by Customer
                        </h4>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <p style={{ display: "inline" }}>
                            I/We agree about the results and Raw data submitted against the above-mentioned details of the said Project SO… for NGS work and accept the closure report.
                        </p>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <p style={{ display: "inline" }}>
                        Signature
                        </p>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <p style={{ display: "inline" }}>
                        Date : 
                        </p>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <p style={{ display: "inline" }}>
                        Name : 
                        </p>
                    </div>

                    <footer
                        style={{
                            background: "#33c9dc",
                            textAlign: "center",
                            padding: "20px",
                            border: "2px solid black"
                        }}
                    >
                        <p>
                            <b>Redcliffe Lifesciences Pvt. Ltd.</b> &nbsp;{" "}
                            <p style={{ display: "inline" }}>
                                Building No: 14, 2nd Floor, Kausalya Park, Hauz Khas, New Delih
                                110016
                            </p>
                        </p>

                        <p>
                            Phone: +91-8882-914-915 | &nbsp; Email: care@redcliffelabs.com |
                            &nbsp; Website: www.redcliffelabs.com
                        </p>
                    </footer>
                </div>
            </div>
        </>
    );
}
const mapStateToProps = (state: any) => ({
    projects: state.GenomicsLabReducer.projects,
    fetchFinalReportData: state.GenomicsLabReducer.fetchFinalReportData,
})

export default connect(mapStateToProps, {
    getProjects,
    FetchFinalReport,
})(PhleboAdminViewBooking);